import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listHistory } from "../../Redux/actions/patientActions/historyActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import "../../App.css";

const HistoryScreen = () => {
  const dispatch = useDispatch();
  const { loading, error, history } = useSelector((state) => state.history);

  useEffect(() => {
    dispatch(listHistory());
  }, [dispatch]);

  return (
    <div className="history-container">
      <div className="history-card">
        <h2 className="appointment-title mb-4">Patient History</h2>
        {loading && <Loading />}
        {error && <Error message={error} />}
        <div className="table-responsive">
          <table className="table table-striped mt-3">
            <thead className="table-teal">
              <tr>
                <th>Date</th>
                <th>Doctor</th>
                <th>Diagnosis</th>
                <th>Lab Test</th>
                <th>Medicines</th>
              </tr>
            </thead>
            <tbody>
              {history && history.map((record) => (
                <tr key={record._id}>
                  <td>{new Date(record.date).toLocaleDateString()}</td>
                  <td>{record.doctor.name}</td>
                  <td>{record.diagnosis}</td>
                  <td>{record.labTests?.map(l => l.testName).join(", ")}</td>
                  <td>{record.medicines?.map(m => m.name).join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HistoryScreen;
